(function(){
function init(root){
  if(!root||root.dataset.jzfReady) return; root.dataset.jzfReady='1';
  var cfgEl=root.querySelector('[data-jzf-config]'); var C={}; try{ C=JSON.parse(cfgEl.textContent); }catch(e){ return; }
  var SID=C.sid;
  var NS='http://www.w3.org/2000/svg', XL='http://www.w3.org/1999/xlink';
  var svg=root.querySelector('[data-jzf-svg]');
  var copy=root.querySelector('.jzf-copy'), track=root.querySelector('.jzf-track');
  var elCycle=root.querySelector('[data-jzf-cycle]'), elStage=root.querySelector('[data-jzf-stage]'), elText=root.querySelector('[data-jzf-text]'), elPerson=root.querySelector('[data-jzf-person]'), elPersonK=root.querySelector('[data-jzf-person-k]'), hint=root.querySelector('[data-jzf-hint]');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var autoplay=C.autoplay===true&&!reduce;

  var COL=['#8A7A6C','#5C8A72','#B65A36','#D8C4B0'], GLOW='#E9A07A', HUB='#1E1611';
  var NAMES=C.names;
  var WHAT=C.what;
  var CYCLES=C.cycles;
  var HUBS=C.hubs;
  var PEOPLE=C.people;
  var ORDER=['musk','slattery','jobs','bouris'], pi=0;
  var showPeople=!!C.showPeople;
  if(!showPeople){ elPerson.hidden=true; elPersonK.hidden=true; }

  // scene is 1400 x 860 units; three wheels on an incline
  var WHEELS=[{x:215,y:660,r:112,w:38},{x:610,y:470,r:160,w:54},{x:1060,y:300,r:212,w:70}];
  var STARTS=[273,3,93,183];
  function el(t,a,p){var e=document.createElementNS(NS,t);for(var k in a)e.setAttribute(k,a[k]);(p||svg).appendChild(e);return e}
  function P(w,a,r){var t=a*Math.PI/180;return [w.x+r*Math.cos(t),w.y+r*Math.sin(t)]}

  var defs=el('defs',{});
  var f=el('filter',{id:'jzf-glow-'+SID,x:'-100%',y:'-100%',width:'300%',height:'300%'},defs);
  el('feGaussianBlur',{stdDeviation:'9',result:'b'},f);
  var m=el('feMerge',{},f); el('feMergeNode',{'in':'b'},m); el('feMergeNode',{'in':'SourceGraphic'},m);
  var mk=el('marker',{id:'jzf-head-'+SID,orient:'auto',markerWidth:'8',markerHeight:'8',refX:'4',refY:'4'},defs);
  el('path',{d:'M0 0 L8 4 L0 8 Z',fill:GLOW},mk);
  el('line',{x1:40,y1:845,x2:1380,y2:120,stroke:GLOW,'stroke-width':2,'stroke-dasharray':'6 10',opacity:.22});

  var conns=[];
  function connector(a,b){var s=P(a,259,a.r),e=P(b,273,b.r);return 'M '+s[0]+' '+s[1]+' C '+(s[0]+40)+' '+(s[1]-a.r*1.4)+', '+(e[0]-b.r*1.3)+' '+(e[1]-b.r*1.2)+', '+e[0]+' '+e[1]}
  for(var k=0;k<2;k++) conns.push(el('path',{d:connector(WHEELS[k],WHEELS[k+1]),fill:'none',stroke:GLOW,'stroke-width':4,'stroke-dasharray':'10 9',opacity:.3,'marker-end':'url(#jzf-head-'+SID+')'}));
  (function(){var w=WHEELS[2],s=P(w,259,w.r);conns.push(el('path',{d:'M '+s[0]+' '+s[1]+' C '+(s[0]+30)+' '+(s[1]-140)+', 1230 -10, 1385 30',fill:'none',stroke:GLOW,'stroke-width':4,'stroke-dasharray':'10 9',opacity:.3,'marker-end':'url(#jzf-head-'+SID+')'}))})();
  var more=el('text',{x:1388,y:62,'text-anchor':'end',fill:GLOW,'font-size':18,'font-weight':600,opacity:.3}); more.textContent=C.never||'';

  var groups=[],segs=[];
  WHEELS.forEach(function(w,k){
    var g=el('g',{style:'transform-origin:'+w.x+'px '+w.y+'px;transition:opacity .6s, transform .8s cubic-bezier(.2,.8,.2,1)'});
    groups.push(g);
    el('circle',{'class':'jzf-spin',cx:w.x,cy:w.y,r:w.r+w.w/2+16,fill:'none',stroke:'#D8C4B0','stroke-width':2,'stroke-dasharray':'2 14',opacity:.45},g);
    var row=[], fs=Math.round(w.w*0.46);
    for(var i=0;i<4;i++){
      var a1=STARTS[i],a2=a1+76,p1=P(w,a1,w.r),p2=P(w,a2,w.r);
      var sg=el('g',{style:'transition:opacity .35s'},g);
      el('path',{d:'M '+p1[0]+' '+p1[1]+' A '+w.r+' '+w.r+' 0 0 1 '+p2[0]+' '+p2[1],fill:'none',stroke:COL[i],'stroke-width':w.w},sg);
      var tip=P(w,a2+9,w.r),b1=P(w,a2,w.r-w.w*.8),b2=P(w,a2,w.r+w.w*.8);
      el('polygon',{points:b1[0]+','+b1[1]+' '+tip[0]+','+tip[1]+' '+b2[0]+','+b2[1],fill:COL[i]},sg);
      // stage name curved along the ring, inside the band; bottom-half labels run the other way so they read upright
      var flip=(i===1||i===2), la=a1+5, lb=a2-5, q1=P(w,flip?lb:la,w.r), q2=P(w,flip?la:lb,w.r), pid='jzf-'+SID+'-'+k+'-'+i;
      el('path',{id:pid,d:'M '+q1[0]+' '+q1[1]+' A '+w.r+' '+w.r+' 0 0 '+(flip?0:1)+' '+q2[0]+' '+q2[1],fill:'none'},defs);
      var t=el('text',{fill:i===3?HUB:'#FFFFFF','font-weight':700,'font-size':fs,'letter-spacing':'.05em','dominant-baseline':'central'},sg);
      var tp=document.createElementNS(NS,'textPath'); tp.setAttribute('href','#'+pid); tp.setAttributeNS(XL,'xlink:href','#'+pid); tp.setAttribute('startOffset','50%'); tp.setAttribute('text-anchor','middle');
      tp.textContent=(k===0?'':(i+1)+'  ')+NAMES[i].toUpperCase(); t.appendChild(tp);
      row.push(sg);
    }
    segs.push(row);
    el('circle',{cx:w.x,cy:w.y,r:w.r-w.w/2-10,fill:HUB,stroke:'#3A2E26','stroke-width':1},g);
    var ha=el('text',{x:w.x,y:w.y-(k===0?6:(k===1?8:10)),'text-anchor':'middle',fill:'#E9A07A','font-weight':600,'font-size':k===0?11:(k===1?13:16),'letter-spacing':'2'},g); ha.textContent=HUBS[k][0];
    var hb=el('text',{x:w.x,y:w.y+(k===0?16:(k===1?22:28)),'text-anchor':'middle',fill:'#F6EFE4','font-family':'var(--f-display, Bodoni Moda, Didot, serif)','font-weight':400,'font-size':k===0?18:(k===1?26:36)},g); hb.textContent=HUBS[k][1];
  });

  var trail=[]; for(var i=0;i<8;i++) trail.push(el('circle',{r:10-i,fill:GLOW,opacity:(.35-i*.04).toFixed(2)}));
  var token=el('circle',{r:13,fill:'#FFF3E3',stroke:GLOW,'stroke-width':4,filter:'url(#jzf-glow-'+SID+')'});

  var LOOP=4600,JUMP=1500,HOLD=2800,phases=[],t0=0;
  for(var k2=0;k2<3;k2++){phases.push({type:'loop',k:k2,s:t0,e:t0+LOOP});t0+=LOOP;phases.push({type:'jump',k:k2,s:t0,e:t0+JUMP});t0+=JUMP;}
  phases.push({type:'hold',s:t0,e:t0+HOLD}); t0+=HOLD; var TOTAL=t0;
  function ease(x){return x<.5?2*x*x:1-Math.pow(-2*x+2,2)/2}

  // ---- camera: follows the marker, zooms out as the wheels get bigger ----
  var asp=1400/860, cam=null, camT=null, camRaf=null;
  function measure(){ var r=svg.getBoundingClientRect(); if(r.width>0&&r.height>0) asp=r.width/r.height; }
  function focus(k){ var w=WHEELS[k]; return {cx:w.x,cy:w.y,hs:(w.r+w.w/2+16)*1.32}; }
  function full(){ if(window.innerWidth<860) return {cx:1000,cy:330,hs:440}; var w=1560, h=Math.max(900,w/asp); return {cx:700,cy:420,hs:h/2}; }
  function mix(a,b,u){ return {cx:a.cx+(b.cx-a.cx)*u, cy:a.cy+(b.cy-a.cy)*u, hs:a.hs+(b.hs-a.hs)*u}; }
  function applyCam(){ var h=cam.hs*2, w=h*asp; svg.setAttribute('viewBox',(cam.cx-w/2).toFixed(1)+' '+(cam.cy-h/2).toFixed(1)+' '+w.toFixed(1)+' '+h.toFixed(1)); }
  function camStep(){ camRaf=null; if(!camT) return; var d=0;
    ['cx','cy','hs'].forEach(function(p){ var df=camT[p]-cam[p]; d+=Math.abs(df); cam[p]+=df*0.09; });
    applyCam(); if(d>0.6) camRaf=requestAnimationFrame(camStep); }
  function setCam(t,snap){ camT=t; if(!cam||snap){ cam={cx:t.cx,cy:t.cy,hs:t.hs}; applyCam(); return; } if(!camRaf) camRaf=requestAnimationFrame(camStep); }

  var lastKey='';
  function caption(k,i){
    var key=k+'-'+i+'-'+pi; if(key===lastKey) return; lastKey=key;
    elCycle.textContent=CYCLES[k]; elStage.textContent=NAMES[i]; elStage.style.color=COL[i]; elText.textContent=WHAT[i];
    if(showPeople){ elPerson.textContent=PEOPLE[ORDER[pi]][k]; }
  }
  function setWheels(reached,active,stage){
    groups.forEach(function(g,k){
      g.style.opacity=k<=reached?1:.12; g.style.transform=k<=reached?'scale(1)':'scale(.86)';
      segs[k].forEach(function(s,i){ s.style.opacity = k===active ? (i===stage?1:.42) : ((k<reached||(k===reached&&active===-1))?.7:1); });
    });
    conns.forEach(function(c,k){ c.setAttribute('opacity', (k<reached||(k===reached&&active===-1))?.9:.3); });
    more.setAttribute('opacity', (reached>=2&&active===-1)?.95:.3);
  }
  var hist=[];
  function place(x,y){ if(hist[0]&&Math.abs(x-hist[0][0])+Math.abs(y-hist[0][1])>70) hist=[]; hist.unshift([x,y]); hist.length=trail.length*3; token.setAttribute('cx',x); token.setAttribute('cy',y);
    trail.forEach(function(c,i){ var h=hist[(i+1)*3]||hist[hist.length-1]; if(h){c.setAttribute('cx',h[0]);c.setAttribute('cy',h[1]);} }); }
  function frame(t,snap){
    var ph=null; for(var i=0;i<phases.length;i++){ if(t>=phases[i].s&&t<phases[i].e){ph=phases[i];break;} } if(!ph) ph=phases[phases.length-1];
    var u=Math.min(1,Math.max(0,(t-ph.s)/(ph.e-ph.s)));
    var vis=1;
    if(ph.type==='loop'){
      var w=WHEELS[ph.k], a=273+ease(u)*(259+360-273), i=Math.min(3,Math.floor(((a-273)%360)/90)), p=P(w,a,w.r);
      place(p[0],p[1]); setWheels(ph.k,ph.k,i); caption(ph.k,i); setCam(focus(ph.k),snap);
    } else if(ph.type==='jump'){
      var c=conns[ph.k], L=c.getTotalLength(), pt=c.getPointAtLength(ease(u)*L);
      place(pt.x,pt.y); setWheels(ph.k<2?(u>.55?ph.k+1:ph.k):2,-1,3); caption(ph.k,3);
      setCam(mix(focus(ph.k), ph.k<2?focus(ph.k+1):full(), ease(u)),snap);
    } else { vis=1-u; setWheels(2,-1,3); setCam(full(),snap); }
    token.setAttribute('opacity',vis); trail.forEach(function(c,i){ c.setAttribute('opacity', vis*(.35-i*.04)); });
    return ph;
  }

  // ---- modes: autoplay (idle at top) vs scroll scrub ----
  var mode='auto', elapsed=0, last=null, raf=null;
  function tick(now){
    if(last!==null){ var ne=elapsed+(now-last); if(ne>=TOTAL){ pi=(pi+1)%ORDER.length; lastKey=''; } elapsed=ne%TOTAL; }
    last=now; frame(elapsed); raf=requestAnimationFrame(tick);
  }
  function startAuto(){ if(mode==='auto'&&raf) return; mode='auto'; last=null; copy.classList.remove('is-close'); raf=requestAnimationFrame(tick); }
  function stopAuto(){ mode='scroll'; if(raf){cancelAnimationFrame(raf);raf=null;} }

  function headerOffset(){
    var h=document.querySelector('#shopify-section-header, .shopify-section-group-header-group, header');
    if(!h) return 0; var pos=getComputedStyle(h).position;
    if(pos!=='sticky'&&pos!=='fixed'){ var inner=h.querySelector('header,.header'); if(inner){pos=getComputedStyle(inner).position; if(pos==='sticky'||pos==='fixed') return inner.offsetHeight;} return 0; }
    return h.offsetHeight;
  }
  function layout(){ root.style.setProperty('--jzf-top', headerOffset()+'px'); measure(); if(cam) applyCam(); }
  layout(); window.addEventListener('resize',layout);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(layout);

  function progress(){
    var rect=track.getBoundingClientRect(), top=headerOffset(), vh=window.innerHeight-top;
    var total=rect.height-vh; if(total<=0) return 0;
    return Math.min(1,Math.max(0,(-rect.top+top)/total));
  }
  function onScroll(){
    var p=progress();
    if(p<=0.004){
      if(hint) hint.classList.remove('is-off');
      copy.classList.remove('is-caption','is-close');
      if(autoplay){ if(mode!=='auto') startAuto(); } else { frame(0); }
      return;
    }
    if(hint) hint.classList.add('is-off');
    if(mode!=='scroll') stopAuto();
    var t=p*TOTAL; elapsed=t; var ph=frame(t);
    if(ph.type==='hold'||p>0.985){ copy.classList.remove('is-caption'); copy.classList.add('is-close'); }
    else { copy.classList.add('is-caption'); copy.classList.remove('is-close'); }
  }
  var ticking=false;
  window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ ticking=false; onScroll(); }); } },{passive:true});

  // first paint
  if(reduce){ frame(phases[phases.length-1].e-1,true); setWheels(2,-1,3); }
  else if(autoplay){ frame(0,true); startAuto(); }
  else { frame(0,true); }
  onScroll();

  // ---- reveal the rest of the page as it scrolls into view ----
  if(C.reveal===true && 'IntersectionObserver' in window && !reduce){
    var mine=root.closest('.shopify-section')||root, sib=mine.nextElementSibling, targets=[];
    while(sib){ if(sib.classList&&sib.classList.contains('shopify-section')&&sib.offsetHeight>0) targets.push(sib); sib=sib.nextElementSibling; }
    var extra=document.querySelector('#shopify-section-follow-social'); if(extra&&targets.indexOf(extra)<0) targets.push(extra);
    var io=new IntersectionObserver(function(entries){ entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } }); },{threshold:0.08,rootMargin:'0px 0px -6% 0px'});
    targets.forEach(function(t){ var r=t.getBoundingClientRect(); if(r.top<window.innerHeight*0.9){ return; } t.classList.add('jzf-reveal'); io.observe(t); });
  }
}
function boot(){ var all=document.querySelectorAll('[data-jzf]'); for(var i=0;i<all.length;i++) init(all[i]); }
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
document.addEventListener('shopify:section:load',function(e){ var r=e.target&&e.target.querySelector&&e.target.querySelector('[data-jzf]'); if(r){ delete r.dataset.jzfReady; init(r); } });
})();